module.exports = __webpack_public_path__ + "img/fontItalicWhite.2333dbcd.svg";